import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EEstateType } from '../../../../api-models/common/json_query';

const ID = 'estateType' as const;

const ESTATE_TYPE_MAP_VALUE_TO_LABEL: Record<EEstateType, string> = {
  [EEstateType.Rent]: 'В аренде',
  [EEstateType.Owned]: 'В собственности',
};

export const estateTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const estateTypes = getTermsValue('estate_type')(jsonQuery);

    if (estateTypes === null) {
      return null;
    }

    return estateTypes.map(estateType => ({
      label: ESTATE_TYPE_MAP_VALUE_TO_LABEL[estateType],
      value: createTagValue(ID, estateType.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const estateTypes = getTermsValue('estate_type')(jsonQuery);

    if (estateTypes === null) {
      return jsonQuery;
    }

    const nextEstateTypes = estateTypes.filter(estateType => String(estateType) !== removingTagValue);

    return nextEstateTypes.length > 0
      ? setTerms('estate_type')(jsonQuery)(nextEstateTypes)
      : resetTerms(['estate_type'])(jsonQuery);
  },
};
